import styles from './TableFilters.module.css';

/**
 * Table filters container with space-between layout
 * @param {object} props
 * @param {React.ReactNode} props.children - Filter groups or other content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactNode}
 */
function TableFilters({ children, className = '' }) {
  return (
    <div id="table-filters" className={`${styles['table-filters']} ${className}`}>
      {children}
    </div>
  );
}

/**
 * Lays out filter groups + search: column on small viewports, full-width row with
 * filters on the left and search aligned to the right from `--breakpoint-mobile` + 1px up.
 * @param {object} props
 * @param {React.ReactNode} props.children - Typically two `TableFiltersGroup` nodes
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactNode}
 */
export function TableFiltersToolbar({ children, className = '' }) {
  return (
    <div className={`${styles['table-filters-toolbar']} ${className}`}>
      {children}
    </div>
  );
}

/**
 * Table filters group component for grouping related filters
 * @param {object} props
 * @param {React.ReactNode} props.children - Filter items
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactNode}
 */
export function TableFiltersGroup({ children, className = '' }) {
  return (
    <div className={`${styles['table-filters-group']} ${className}`}>
      {children}
    </div>
  );
}

export default TableFilters;
